"use client";

import { stripeClient as stripeClientPlugin } from "@better-auth/stripe/client";
import {
  customSessionClient,
  emailOTPClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import type { AuthInstance } from "./server";

export const authClient = createAuthClient({
  plugins: [
    emailOTPClient(),
    customSessionClient<AuthInstance>(),
    stripeClientPlugin({
      subscription: true,
    }),
  ],
});

export const useAuthSession = () => authClient.useSession();

export const useRequireAuth = () => {
  const session = useAuthSession();
  const router = useRouter();
  const hasSession = Boolean(session.data);

  useEffect(() => {
    if (session.isPending || hasSession) {
      return;
    }
    router.push("/auth");
  }, [router, hasSession, session.isPending]);

  return session;
};
